import type { IxcGenerateV1TradeConfirmationsTaskKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../../util/routing/entity-paths';

export const DOCGEN_TRADE_CONFIRMATION_TASK_BASE_PATH = getResolvedPath('/clearing/operations/generate/trade-confirmation/task');

export const getDocgenTradeConfirmationTaskPath: EntityPathBuilder<IxcGenerateV1TradeConfirmationsTaskKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return DOCGEN_TRADE_CONFIRMATION_TASK_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.taskId) {
        return undefined;
      }

      return getResolvedPath(`${DOCGEN_TRADE_CONFIRMATION_TASK_BASE_PATH}/$taskId`, context.keys);
    }
  }
};

export function getDocgenTradeConfirmationTaskDetailPath(taskId: string | undefined) {
  if (!taskId) {
    return undefined;
  }

  return getDocgenTradeConfirmationTaskPath({ kind: 'detail', keys: { taskId } });
}
